<section class="approvers">
  <div class="approvers--header">
    <h5
      class="approvers--header__title"
      *ngIf="!isDetail && showController && showAuthorizer"
    >
      {{ 'approversTitle' | i18next }}
    </h5>
    <h5
      class="approvers--header__title"
      *ngIf="!isDetail && !extendTransfer && showController && !showAuthorizer"
    >
      {{ 'selectCont' | i18next }}
    </h5>
    <h5
      class="approvers--header__title"
      *ngIf="!isDetail && showAuthorizer && !showController"
    >
      {{ 'selectAuth' | i18next }}
    </h5>
    <h5 *ngIf="isDetail" class="approvers--header__title">
      {{ 'approvers' | i18next }}
    </h5>
  </div>
  <form
    class="approvers--container"
    *ngIf="(!requestStatus || isModify) && !notModifyController"
  >
    <div class="approvers--container__item" *ngIf="showAuthorizer">
      <div class="flex-container">
        <mat-form-field class="width-standar">
          <mat-label>{{ 'authorizer' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ 'selectAuth' | i18next }}"
            [formControl]="authorizerControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onAuthorizerSelectionChange($event)"
          >
            <mat-option
              *ngFor="let authorizer of filteredAuthorizers"
              [value]="authorizer"
            >
              {{ authorizer.fullName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <small *ngIf="authorizers.length === 0" class="error-msg">{{
        'errorGetAuthorizers' | i18next
      }}</small>
      <small
        *ngIf="
          (authorizerControl.invalid && authorizerControl.touched) ||
          (!selectAuthorizer.id && authorizerControl.touched)
        "
        class="error-msg"
        >{{ 'errorAuthorizer' | i18next }}</small
      >
    </div>
    <div class="approvers--container__item" *ngIf="showController">
      <div class="flex-container">
        <mat-form-field class="width-standar">
          <mat-label>{{ 'controller' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ 'selectCont' | i18next }}"
            [formControl]="controllerControl"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="onControllerSelectionChange($event)"
          >
            <mat-option
              *ngFor="let controller of filteredControllers"
              [value]="controller"
            >
              {{ controller.fullName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <small *ngIf="controllers.length === 0" class="error-msg">{{
        'errorGetControllers' | i18next
      }}</small>
      <small
        *ngIf="
          (controllerControl.invalid && controllerControl.touched) ||
          (!selectController.id && controllerControl.touched)
        "
        class="error-msg"
        >{{ 'errorController' | i18next }}</small
      >
    </div>
  </form>
  <small class="error-message" *ngIf="authorizerError || controllerError">{{
    'selectType' | i18next
  }}</small>
  <section
    class="section"
    *ngIf="(controller || authorizer) && (!isModify || notModifyController)"
  >
    <div class="approversForm">
      <div *ngIf="authorizer">
        <div class="rowInfo">
          <p class="label">
            {{ 'authorizer' | i18next }}
          </p>
          <p class="text">{{ authorizer.id }} - {{ authorizer.fullName }}</p>
        </div>
      </div>
      <div *ngIf="controller">
        <div class="rowInfo">
          <p class="label">
            {{ 'controller' | i18next }}
          </p>
          <p class="text">{{ controller.id }} - {{ controller.fullName }}</p>
        </div>
      </div>
    </div>
  </section>
  <button
    *ngIf="isModify && type !== requestTypeEnum.proyect"
    class="approvers--btn"
    [disabled]="errorAuthorizers"
    [ngStyle]="
      errorAuthorizers
        ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
        : { 'background-color': '#c8f546' }
    "
    (click)="sendNewApprovers()"
  >
    {{ 'btnSave' | i18next | uppercase }}
  </button>
  <p
    *ngIf="isModify && errorAuthorizers && !notModifyController"
    class="error-msg"
  >
    {{ 'errorAuthorizer' | i18next }}
  </p>
</section>
